export default __webpack_public_path__ + "static/media/m-20.69bf0ea4.svg";